const store = {
    namespaced: true,
    state: {
        participantId: null, 
        docRecords: [],
        ready:false,
        docRecord:null,
    },
    actions:
    {
        async load({ state, commit }, data) {
            
            if (data.participantId) {
                commit("setParticipantId", data.participantId);
                commit("setReady", false);
                let result = await romeApi.get(`/participant/${data.participantId}/docrecord/all`);
                commit("setDocRecords",result);
                commit("setReady",true);
            }
            else{
                commit("reset");
                commit("setReady",true);
            }
        },
        async download({ state, commit }, data){
            console.log(data);
            if(data.participantId){
                commit("setReady", false);
                let result = await romeApi.get(`/participant/${data.participantId}/docrecord/${data.docId}`);
                console.log(result);
                commit("setDocRecord",result);
                commit("setReady",true);
      
            }
          
        }
    },
    mutations: {
        setParticipantId(state, value) {
            state.participantId = value;
        },
        setReady(state, value) {
            state.ready = value;             
        },
        reset(state) {
            Object.keys(state).forEach(key => {
                if(key == "ready")
                {
                    state[key] = false;
                }
                else{
              state[key] = null; }
            })
        },
        setDocRecords(state, value) {
            state.docRecords = value;
        },
        setDocRecord(state,value){
            state.docRecord = value;
        }
    }
};

export default store;


// WEBPACK FOOTER //
// ./src/docRecord/x-doc-record.js